<!-----导航菜单区域----->
<template>
  <div class="container" :style="`color:${theme==='black' || headerTheme==='black'?'#303133':'#fff'};position:${position}`">
    <div class="content">
			<div class="left">
				<el-image class="logo" :src="logoBlack" fit="fill" @click="goPage('index',1)" v-show="theme==='black' || headerTheme==='black'"></el-image>
				<el-image class="logo" :src="logo" fit="fill" @click="goPage('index',1)" v-show="theme!=='black' && headerTheme!=='black'"></el-image>
			</div>
			<div class="right">
				<span :class="`${headerMenuActiveIndex==1?'active':''}`" @click="goPage('index')" >首&nbsp;&nbsp;&nbsp;&nbsp;页</span>
				<span :class="`${headerMenuActiveIndex==2?'active':''}`" @click="goPage('news-list')">新闻中心</span>
				<span :class="`${headerMenuActiveIndex==3?'active':''}`" @click="goPage('product-list')">产品中心</span>
				<span :class="`${headerMenuActiveIndex==4?'active':''}`" @click="goPage('about-us')">关于我们</span>
				<span :class="`${headerMenuActiveIndex==5?'active':''}`" @click="goPage('contact-us')">联系我们</span>
			</div>
    </div>
  </div>
</template>

<script>
export default {
	model: {
    prop: 'theme',
    event: 'change'
  },
	props: {
    theme: {
      default: 'white',
      type: String
    },
		position:{
			default:'fix',
			type:String,
		}
  },
	data(){
		return{
			logo:require("@/assets/img/logo.png"),
			logoBlack:require("@/assets/img/logo-black.png"),
			headerMenuActiveIndex:this.$route.meta.headerMenuActiveIndex || 1,
			headerTheme:this.$route.meta.headerTheme || this.theme || "white",
		}
	},
	methods:{

		//页面跳转
		goPage(name){
			this.$router.push({
				name
			})
		},
	},
}
</script>

<style lang="scss" scoped>
.container{
	position: fixed;
	z-index: 999;

	.content{
		width: 100rem;
		height: 5rem;
		margin: 0 auto;
		font-size: 1.25rem;
		font-weight: 400;
		line-height: 5rem;
		letter-spacing: .0625rem;
		display: flex;
		justify-content: space-between;

		.left{
			display: flex;
			align-items: center;

			.logo{
				width: 18.75rem;
				height: 3.75rem;
				cursor: pointer;
			}
		}
		.right{
			width: 70rem;
			display: flex;
			align-items: center;
			justify-content: flex-end;
		
			span{
				margin-left: 5.3125rem;
				display: flex;
				align-items: center;
				height: 2.5rem;
				cursor: pointer;
			}
			span:hover{
				font-weight: bold;
				color: #409EFF;
			}
			.active{
				font-weight: bold;
				color: #409EFF;
				border-bottom: .125rem solid #409EFF;
			}
		}
	}
		
}
</style>